module.exports = __webpack_public_path__ + "img/liquid.91073362.jpeg";